module.exports = __webpack_public_path__ + "img/epr-article-top-img_medium.e83442c6.jpg";